export default async function preloadWasm(url) {
    const cache = await caches.open("shiver-dicebox-wasm");
    const cachedResponse = await cache.match(url);
    if (cachedResponse) {
        console.log(`DiceBox WASM loaded from cache: ${url}`);
        return await cachedResponse.arrayBuffer();
    }

    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch WASM: ${url}`);
    const buffer = await response.arrayBuffer();
    await cache.put(url, new Response(buffer));
    console.log(`DiceBox WASM fetched & cached: ${url}`);
    return buffer;
}

